// Empty seed data — RRC starts clean. Properties will be populated from the
// first .xlsx upload via the ingest endpoint.
export const fallbackProperties = [];

export const fallbackPeriod = null;
